import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "b-worker-card" }
const _hoisted_2 = { class: "b-worker-card__info b-worker-card__info--align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkerAvatar = _resolveComponent("WorkerAvatar")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.workerUrl,
    class: "b-worker-card__wrapper"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorkerAvatar, {
          worker: _ctx.worker,
          size: "small",
          align: "right"
        }, null, 8, ["worker"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FwIcon, {
            class: "h-flex-center h-pointer",
            icon: "arrow-right",
            size: "14",
            color: "#27dbbd"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}